import React from 'react';
import { withErrorBoundary } from '../components/error-handling';
const withLazy = ({ importFn, loader, errorHandling, }) => {
    const Component = React.lazy(importFn);
    const isSSR = typeof window === 'undefined';
    const renderLoader = (props) => {
        switch (loader?.type) {
            case 'COMPONENT':
                const Component = loader.component;
                return React.createElement(Component, { ...props });
            case 'CHILDREN':
                return React.createElement(React.Fragment, null, props.children);
            default:
                return null;
        }
    };
    const WrappedComponent = (props) => {
        if (isSSR) {
            return renderLoader(props);
        }
        return (React.createElement(React.Suspense, { fallback: renderLoader(props) },
            React.createElement(Component, { ...props })));
    };
    return errorHandling.type === 'PROPAGATE'
        ? WrappedComponent
        : withErrorBoundary(WrappedComponent, errorHandling.fallbackComponent ?? (() => null));
};
export default withLazy;
//# sourceMappingURL=with-lazy.js.map